import * as types from './mutation-types'

// initial state
const state = {
  isCompany: true,

  client: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    country: '',
    address: ''
  },
  company: {
    companyName: '',
    address: '',
    registrationNumber: '',
    iban: '',
    bank: '',
    bic: '',
    vatNumber: ''
  },
  agreeDataTerms: false,
  agreeMailingList: false,
  agreeTermsAndConditions: false,

  templates: [],
  properties: [],
  tickets: [],
  products: [],
  singleProducts: [],
  groupProducts: [],
  currentStep: 1,
  discountCode: "",
  showPayments: false,
  widgetShow: false,
  isPlugin: false
};

// getters
const getters = {
  isCompany: state => state.isCompany,

  clientFirstName: state => state.client.firstName,
  clientLastName: state => state.client.lastName,
  clientAddress: state => state.client.address,
  clientEmail: state => state.client.email,
  clientPhone: state => state.client.phone,
  clientCountry: state => state.client.country,

  companyName: state => state.company.companyName,
  companyAddress: state => state.company.address,
  registrationNumber: state => state.company.registrationNumber,
  iban: state => state.company.iban,
  bank: state => state.company.bank,
  bic: state => state.company.bic,
  vatNumber: state => state.company.vatNumber,

  agreeDataTerms: state => state.agreeDataTerms,
  agreeMailingList: state => state.agreeMailingList,
  agreeTermsAndConditions: state => state.agreeTermsAndConditions,

  templates: state => state.templates,
  properties: state => state.properties,
  tickets: state => state.tickets,
  products: state => state.products,
  singleProducts: state => state.singleProducts,
  groupProducts: state => state.groupProducts,
  currentStep: state => state.currentStep,
  discountCode: state => state.discountCode,
  showPayments: state => state.showPayments,
  widgetShow: state => state.widgetShow,
  isPlugin: state => state.isPlugin,

};

const actions = {};

// mutations
const mutations = {
  [types.SET_IS_COMPANY](state, value) {
    state.isCompany = value
  },
  
  [types.SET_FIRST_NAME](state, value) {
    state.client.firstName = value
  },
  [types.SET_LAST_NAME](state, value) {
    state.client.lastName = value
  },
  [types.SET_ADDRESS](state, value) {
    state.client.address = value
  },
  [types.SET_EMAIL](state, value) {
    state.client.email = value
  },
  [types.SET_PHONE](state, value) {
    state.client.phone = value
  },
  [types.SET_COUNTRY](state, value) {
    state.client.country = value
  },
  [types.SET_COMPANY_NAME](state, value) {
    state.company.companyName = value
  },
  [types.SET_COMPANY_ADDRESS](state, value) {
    state.company.address = value
  },
  [types.SET_REG_NUM](state, value) {
    state.company.registrationNumber = value
  },
  [types.SET_IBAN](state, value) {
    state.company.iban = value
  },
  [types.SET_BANK](state, value) {
    state.company.bank = value
  },
  [types.SET_BIC](state, value) {
    state.company.bic = value
  },
  [types.SET_VAT_NUMBER](state, value) {
    state.company.vatNumber = value
  },
  [types.SET_TERMS_AGREE](state, value) {
    state.agreeDataTerms = value
  },
  [types.SET_MAILING_LIST_AGREE](state, value) {
    state.agreeMailingList = value
  },
  [types.SET_TERMS_CONDITIONS_AGREE](state, value) {
    state.agreeTermsAndConditions = value
  },

  [types.SET_TEMPLATES](state, value) {
    state.templates = value
  },
  [types.SET_PROPERTIES](state, value) {
    state.properties = value
  },
  [types.SET_TICKETS](state, value) {
    state.tickets = value
  },
  [types.SET_PRODUCTS](state, value) {
    state.products = value
  },
  [types.SET_SINGLE_PRODUCTS](state, value) {
    state.singleProducts = value
  },
  [types.SET_GROUP_PRODUCTS](state, value) {
    state.groupProducts = value
  },
  [types.SET_CURRENT_STEP](state, value) {
    state.currentStep = value
  },
  [types.SET_DISCOUNT_CODE](state, value) {
    state.discountCode = value
  },
  [types.SET_SHOW_PAYMENTS](state, value) {
    state.showPayments = value
  },
  [types.SET_WIDGET_SHOW](state, value) {
    state.widgetShow = value
  },
  [types.SET_IS_PLUGIN](state, value) {
    state.isPlugin = value
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}
